export default class CtaPopup {

	constructor(el) {
		this.el = el;

		if(!this.el) {
			return;
		}

		this.breakpoint = window.matchMedia('(max-width:992px)');

		if (this.breakpoint.matches) {
			document.addEventListener("scroll", (event) => {

				if (window.scrollY >= 100) {
					this.el.classList.add('show');
				} else {
					this.el.classList.remove('show');
				}
			});
		}

	}
}